import React, { useState, useCallback, useEffect } from 'react';
import { Modal, Button, Typography } from 'antd';
// import NumbersKeypad from './NumbersKeypad'; // Будет использоваться в будущем

const { Text } = Typography;

const AgeVerificationModal = ({ visible, onCancel, onVerified }) => {
    const [timer, setTimer] = useState(4);

    // Старая реализация (закомментирована для будущего использования)
    /*
    const [mode, setMode] = useState('iin'); // 'iin' или 'manual'
    const [birthDate, setBirthDate] = useState('');
    const [barcodeBuffer, setBarcodeBuffer] = useState('');
    const [lastKeystroke, setLastKeystroke] = useState(0);

    // Валидация ИИН
    const validateIIN = (iin) => {
        if (iin.length !== 12 || !/^\d{12}$/.test(iin)) {
            return { valid: false, error: 'ИИН должен содержать 12 цифр' };
        }

        // Извлекаем дату рождения
        const yy = parseInt(iin.substring(0, 2), 10);
        const mm = parseInt(iin.substring(2, 4), 10);
        const dd = parseInt(iin.substring(4, 6), 10);
        const century = parseInt(iin.charAt(6), 10);

        // Определяем век
        let year;
        if (century === 1 || century === 2) {
            year = 1800 + yy;
        } else if (century === 3 || century === 4) {
            year = 1900 + yy;
        } else if (century === 5 || century === 6) {
            year = 2000 + yy;
        } else {
            return { valid: false, error: 'Неверный формат ИИН (неверный признак века)' };
        }

        // Проверка корректности даты
        if (mm < 1 || mm > 12 || dd < 1 || dd > 31) {
            return { valid: false, error: 'Неверная дата рождения в ИИН' };
        }

        // Создаем дату
        const birthDateObj = new Date(year, mm - 1, dd);

        // Проверяем, что дата корректна
        if (
            birthDateObj.getFullYear() !== year ||
            birthDateObj.getMonth() !== mm - 1 ||
            birthDateObj.getDate() !== dd
        ) {
            return { valid: false, error: 'Некорректная дата рождения в ИИН' };
        }

        return { valid: true, birthDate: birthDateObj };
    };

    // Проверка возраста (полные годы)
    const checkAge = (birthDateObj, requiredAge) => {
        const today = new Date();
        let age = today.getFullYear() - birthDateObj.getFullYear();
        const monthDiff = today.getMonth() - birthDateObj.getMonth();
        const dayDiff = today.getDate() - birthDateObj.getDate();

        // Если день рождения еще не наступил в этом году
        if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
            age--;
        }

        return age >= requiredAge;
    };

    // Обработчик проверки ИИН
    const handleIINVerify = useCallback((iin) => {
        const validation = validateIIN(iin);
        if (!validation.valid) {
            messageApi.error(validation.error);
            setBarcodeBuffer('');
            return;
        }

        // Проверяем возраст (21 год)
        if (!checkAge(validation.birthDate, 21)) {
            messageApi.error('Продажа запрещена: покупателю нет 21 года');
            setBarcodeBuffer('');
            return;
        }

        messageApi.success('Возраст подтвержден');
        onVerified();
        handleReset();
    }, [messageApi, onVerified]);

    // Парсинг даты в формате ДД.ММ.ГГГГ
    const parseManualDate = (dateStr) => {
        const parts = dateStr.split('.');
        if (parts.length !== 3) {
            return null;
        }

        const day = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10);
        const year = parseInt(parts[2], 10);

        if (isNaN(day) || isNaN(month) || isNaN(year)) {
            return null;
        }

        if (month < 1 || month > 12 || day < 1 || day > 31) {
            return null;
        }

        if (year < 1900 || year > new Date().getFullYear()) {
            return null;
        }

        const date = new Date(year, month - 1, day);

        // Проверяем корректность даты
        if (
            date.getFullYear() !== year ||
            date.getMonth() !== month - 1 ||
            date.getDate() !== day
        ) {
            return null;
        }

        return date;
    };

    // Обработчик проверки ручного ввода даты
    const handleManualVerify = useCallback(() => {
        if (!birthDate.trim()) {
            messageApi.warning('Введите дату рождения');
            return;
        }

        const birthDateObj = parseManualDate(birthDate.trim());
        if (!birthDateObj) {
            messageApi.error('Неверный формат даты. Используйте ДД.ММ.ГГГГ');
            return;
        }

        // Проверяем возраст (21 год для не граждан РК)
        if (!checkAge(birthDateObj, 21)) {
            messageApi.error('Продажа запрещена: покупателю нет 21 года');
            return;
        }

        messageApi.success('Возраст подтвержден');
        onVerified();
        handleReset();
    }, [birthDate, messageApi, onVerified]);

    // Сброс состояния
    const handleReset = () => {
        setMode('iin');
        setBirthDate('');
        setBarcodeBuffer('');
    };

    // Обработчик клавиатуры для автосканирования ИИН
    const handleKeyDown = useCallback((e) => {
        if (!visible || mode !== 'iin') return;
        if (document.activeElement && document.activeElement.tagName === 'INPUT') return;

        const currentTime = Date.now();
        const timeDiff = currentTime - lastKeystroke;

        if (timeDiff > 200) {
            setBarcodeBuffer('');
        }

        setLastKeystroke(currentTime);

        if (e.keyCode === 13 || e.keyCode === 10 || e.key === 'Enter') {
            if (barcodeBuffer.length === 12) {
                handleIINVerify(barcodeBuffer);
            }
            setBarcodeBuffer('');
            e.preventDefault();
        } else if (e.key.length === 1 && /[0-9]/.test(e.key)) {
            setBarcodeBuffer(prev => prev + e.key);
            e.preventDefault();
        }
    }, [visible, mode, barcodeBuffer, lastKeystroke, handleIINVerify]);

    // Подписка на события клавиатуры
    useEffect(() => {
        if (visible && mode === 'iin') {
            window.addEventListener('keydown', handleKeyDown, true);
            return () => {
                window.removeEventListener('keydown', handleKeyDown, true);
            };
        }
    }, [visible, mode, handleKeyDown]);

    // Сброс при закрытии
    useEffect(() => {
        if (!visible) {
            handleReset();
        }
    }, [visible]);

    // Обработчик отмены
    const handleCancel = useCallback(() => {
        handleReset();
        onCancel();
    }, [onCancel]);

    // Обработчик клавиатуры для ввода даты
    const handleKeypadPress = useCallback((value) => {
        if (value === 'backspace') {
            setBirthDate(prev => prev.slice(0, -1));
        } else if (value === 'clear') {
            setBirthDate('');
        } else {
            let newValue = birthDate + value;

            // Автоматическая вставка точек
            if (newValue.length === 2 && birthDate.length === 1) {
                newValue += '.';
            } else if (newValue.length === 5 && birthDate.length === 4) {
                newValue += '.';
            }

            // Ограничение длины
            if (newValue.length <= 10) {
                setBirthDate(newValue);
            }
        }
    }, [birthDate]);
    */

    // Вычисление даты для возраста 21+
    const getMinBirthDate = () => {
        const today = new Date();
        const minDate = new Date(today.getFullYear() - 21, today.getMonth(), today.getDate());
        const day = String(minDate.getDate()).padStart(2, '0');
        const month = String(minDate.getMonth() + 1).padStart(2, '0');
        const year = minDate.getFullYear();
        return `${day}.${month}.${year}`;
    };

    // Таймер для задержки кнопки
    useEffect(() => {
        if (visible && timer > 0) {
            const timeout = setTimeout(() => {
                setTimer(prev => prev - 1);
            }, 1000);
            return () => clearTimeout(timeout);
        }
    }, [visible, timer]);

    // Сброс таймера при открытии
    useEffect(() => {
        if (visible) {
            setTimer(4);
        }
    }, [visible]);

    // Обработчик подтверждения
    const handleContinue = useCallback(() => {
        onVerified();
    }, [onVerified]);

    // Обработчик отмены
    const handleCancel = useCallback(() => {
        onCancel();
    }, [onCancel]);

    return (
        <Modal
            open={visible}
            onCancel={handleCancel}
            footer={null}
            width={450}
            centered
            maskClosable={false}
            closable={false}
        >
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textAlign: 'center',
                padding: '20px 0'
            }}>
                {/* SVG иконка 18+ */}
                <div style={{ marginBottom: 24 }}>
                    <svg width="127" height="61" viewBox="0 0 712 344" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M112.583 57.5342H141.891V286.466H112.583V57.5342ZM295.279 57.5342H316.213V286.466H295.279V57.5342ZM254.723 57.5342H270.406V286.466H254.723V57.5342ZM166.764 57.5342H175.67V286.466H166.764V57.5342ZM395.267 57.5342H421.417V286.466H395.267V57.5342ZM341.086 57.5342H370.394V286.466H341.086V57.5342ZM200.543 57.5342H229.851V286.466H200.543V57.5342ZM65.8893 283.027V327.126H122.483V344H57.4447C52.7966 344 49 340.242 49 335.563V283.027H65.8893ZM593.382 0H654.055C658.703 0 662.5 3.79308 662.5 8.43693V60.9728H645.611V16.8739H593.382V0ZM662.5 283.027V335.563C662.5 340.207 658.703 344 654.055 344H593.382V327.126H645.611V283.027H662.5Z" fill="#5C5B5B"/>
                        <path d="M553.671 57.5352H532.736V286.467H553.671V57.5352Z" fill="#5C5B5B"/>
                        <path d="M507.864 57.5352H492.181V286.467H507.864V57.5352Z" fill="#5C5B5B"/>
                        <path d="M467.308 57.5352H438V286.467H467.308V57.5352Z" fill="#5C5B5B"/>
                        <path d="M598.721 57.5352H569.413V286.467H598.721V57.5352Z" fill="#5C5B5B"/>
                        <path d="M65.8893 16.8737V60.9727H49V8.43668C49 3.75768 52.7966 -0.000335693 57.4447 -0.000335693H122.483V16.8737H65.8893Z" fill="#5C5B5B"/>
                        <path d="M0 175H712" stroke="#EB0000" strokeOpacity="0.5" strokeWidth="21"/>
                    </svg>
                </div>

                {/* Текст с датой */}
                <Text style={{ fontSize: '18px', marginBottom: 32, fontWeight: 600, lineHeight: '24px' }}>
                    Убедитесь что дата рождения покупателя ранее<br />
                    <span style={{ fontSize: '20px', fontWeight: 700 }}>{getMinBirthDate()}</span><br />
                    и нажмите "Продолжить"
                </Text>

                {/* Таймер */}
                {timer > 0 && (
                    <Text style={{ marginBottom: 24, fontSize: '14px', color: '#8c8c8c' }}>
                        Через {timer} сек.
                    </Text>
                )}

                {/* Кнопка Продолжить */}
                <Button
                    type="primary"
                    size="large"
                    block
                    onClick={handleContinue}
                    disabled={timer > 0}
                    style={{
                        height: '70px',
                        fontSize: '18px',
                        fontWeight: 600,
                        marginBottom: 16,
                        lineHeight: '23px',
                        letterSpacing: '-0.44px'
                    }}
                >
                    Продолжить
                </Button>

                {/* Кнопка Отмена */}
                <Button
                    size="large"
                    block
                    onClick={handleCancel}
                    style={{
                        height: '70px',
                        fontSize: '18px',
                        fontWeight: 600,
                        lineHeight: '23px',
                        letterSpacing: '-0.44px'
                    }}
                >
                    Отмена
                </Button>
            </div>
        </Modal>
    );
};

export default AgeVerificationModal;
